import { Vector3 as BABYLON_Vector3, Quaternion as BABYLON_Quaternion } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { vector_3 } from './Conversion.js';
/**
  * Calculates the world transform of a scene object.
  * @param scene_object The scene object to calculate the world transform of.
  */
export function calculate_world_transform(scene_object) {
    let position = BABYLON_Vector3.Zero();
    let scale = BABYLON_Vector3.One();
    let rotation = BABYLON_Vector3.Zero();
    let parent_object = scene_object;
    do {
        const new_transform = calculate_transform_from_parent_world_transform({
            position: parent_object.get_position(),
            scale: parent_object.get_scale(),
            rotation: parent_object.get_rotation()
        }, position, scale, rotation);
        position = vector_3(new_transform.position);
        scale = vector_3(new_transform.scale);
        rotation = vector_3(new_transform.rotation);
        parent_object = parent_object.parent;
    } while (parent_object);
    return { position: position, scale: scale, rotation: rotation };
}
/**
* Calculates the world transform of a scene object from a parent world transform.
* @param parent_transform The parent world transform.
* @param position The position of the scene object.
* @param scale The scale of the scene object.
* @param rotation The rotation of the scene object.
*/
export function calculate_transform_from_parent_world_transform(parent_transform, position = BABYLON_Vector3.Zero(), scale = BABYLON_Vector3.One(), rotation = BABYLON_Vector3.Zero()) {
    const parent_rotation = parent_transform.rotation;
    const parent_rotation_quat = BABYLON_Quaternion.RotationYawPitchRoll(parent_rotation.y, parent_rotation.x, parent_rotation.z);
    const child_rotation_quat = BABYLON_Quaternion.RotationYawPitchRoll(rotation.y, rotation.x, rotation.z);
    const rotation_quat = parent_rotation_quat.multiply(child_rotation_quat);
    const vec3_offset_scaled = new BABYLON_Vector3(position.x, position.y, position.z);
    const parent_scale = parent_transform.scale;
    vec3_offset_scaled.x *= parent_scale.x;
    vec3_offset_scaled.y *= parent_scale.y;
    vec3_offset_scaled.z *= parent_scale.z;
    const rotated_offset = vec3_offset_scaled.rotateByQuaternionToRef(parent_rotation_quat, new BABYLON_Vector3(0.0, 0.0, 0.0));
    const parent_position = parent_transform.position;
    const new_position = new BABYLON_Vector3(parent_position.x + rotated_offset.x, parent_position.y + rotated_offset.y, parent_position.z + rotated_offset.z);
    const new_scale = new BABYLON_Vector3(scale.x, scale.y, scale.z).multiply(vector_3(parent_scale));
    return { position: new_position, scale: new_scale, rotation: rotation_quat.toEulerAngles() };
}
/**
* Calculates the world direction of a scene object from a parent world transform.
* @param parent_transform The parent world transform.
* @param direction The direction of the scene object.
*/
export function calculate_direction_from_parent_world_transform(parent_transform, direction) {
    const rotation = parent_transform.rotation;
    const rotation_quaternion = BABYLON_Quaternion.RotationYawPitchRoll(rotation.y, rotation.x, rotation.z);
    const new_direction = new BABYLON_Vector3(direction.x, direction.y, direction.z);
    new_direction.rotateByQuaternionToRef(rotation_quaternion, new_direction);
    return new_direction;
}
//# sourceMappingURL=TransformHelper.js.map